export const DEFAULT_BRAND = {
  primary: "#4E1D5E",
  secondary: "#772F88",
  accent: "#A4A510",
  background: "#FEFCF4",
};

export const brandVars = (colors) => {
  const c = { ...DEFAULT_BRAND, ...(colors || {}) };
  return {
    "--pgm-wine": c.primary,
    "--pgm-magenta": c.secondary,
    "--pgm-olive": c.accent,
    "--pgm-cream": c.background,
  };
};
